
import "../common/Focusable/Focusable.st.css.js";
import "../Text/Caption.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_Badge";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_Badge__root","text-tiny-bold":"wds_1_76_1_StylableTypography__text-tiny-bold","prefix":"wds_1_76_1_Badge__prefix","suffix":"wds_1_76_1_Badge__suffix","BadgeStyle":"wds_1_76_1_Badge__BadgeStyle","text":"wds_1_76_1_Badge__text"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"backgroundColor":"grey","borderColor":"grey","color":"var(--wsr-color-D80, #FFFFFF)","padding":"5px 12px","medium":"0px 12px","small":"0px 6px","tiny":"0px 5.5px","mediumHeight":"24px","smallHeight":"18px","tinyHeight":"18px"}; 
export var vars = {}; 




